module.exports = __webpack_public_path__ + "static/media/SRWF 2023.a2bd99ce.PNG";